// Single product gallery behavior migrated from legacy `js/product.js`.
// Relies on global Swiper (loaded by the theme).

(() => {
  const root = document.querySelector(".c-single-product__gallery");
  if (!root) return;

  const productGalleryMain = document.querySelector(".product__gallery__main");
  if (!productGalleryMain) return;

  const productGalleryThumbs = document.querySelector(".product__gallery__thumbs");
  const paginationEl = document.querySelector(".product__gallery__pagination");

  function setGalleryState(isReady) {
    productGalleryMain.classList.toggle("is-swiper-ready", isReady);
    productGalleryMain.setAttribute(
      "data-slider-state",
      isReady ? "enhanced" : "static"
    );
  }

  let galleryMain;
  let galleryThumbs;

  function cleanupAfterDestroy() {
    // Swiper leaves inline styles on these elements; clean them so desktop layout is stable.
    const wrapper = productGalleryMain.querySelector(".swiper-wrapper");
    const slides = productGalleryMain.querySelectorAll(".swiper-slide");
    const thumbsWrapper = productGalleryThumbs
      ? productGalleryThumbs.querySelector(".swiper-wrapper")
      : null;
    const thumbSlides = productGalleryThumbs
      ? productGalleryThumbs.querySelectorAll(".swiper-slide")
      : [];

    productGalleryMain.removeAttribute("style");
    if (wrapper) wrapper.removeAttribute("style");
    slides.forEach((s) => s.removeAttribute("style"));

    if (productGalleryThumbs) {
      productGalleryThumbs.removeAttribute("style");
      if (thumbsWrapper) thumbsWrapper.removeAttribute("style");
      thumbSlides.forEach((s) => s.removeAttribute("style"));
    }

    setGalleryState(false);
  }

  function enableMobileSlider() {
    if (galleryMain || !window.Swiper) return;

    // Thumbs pagination (6 visible on mobile, horizontally scrollable).
    if (productGalleryThumbs) {
      galleryThumbs = new window.Swiper(".product__gallery__thumbs", {
        direction: "horizontal",
        slidesPerView: "auto",
        spaceBetween: 4,
        centerInsufficientSlides: true,
        watchSlidesProgress: true,
        watchOverflow: true,
      });
    }

    galleryMain = new window.Swiper(".product__gallery__main", {
      direction: "horizontal",
      spaceBetween: 0,
      slidesPerView: 1,
      centeredSlides: false,
      loop: false,
      watchOverflow: true,
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: false,
          }
        : undefined,
      thumbs: galleryThumbs ? { swiper: galleryThumbs } : undefined,
    });

    setGalleryState(true);
  }

  function disableSlider() {
    if (!galleryMain) {
      cleanupAfterDestroy();
      return;
    }

    galleryMain.destroy(true, true);
    galleryMain = null;

    if (galleryThumbs) {
      galleryThumbs.destroy(true, true);
      galleryThumbs = null;
    }

    cleanupAfterDestroy();
  }

  const mql = window.matchMedia("(max-width: 991px)");
  const apply = () => {
    if (mql.matches) enableMobileSlider();
    else disableSlider();
  };

  apply();

  if (typeof mql.addEventListener === "function") {
    mql.addEventListener("change", apply);
  } else {
    // Safari fallback
    mql.addListener(apply);
  }
})();

